export interface UserJurisdiction {
  jurisdictionId: string;
  jurisdictionName: string;
  viewPort: {
    minLongitude: number;
    minLatitude: number;
    maxLongitude: number;
    maxLatitude: number;
  };
}

export interface UserDataScope {
  allowedSportIds: string[] | null;
  allowedLeagueIds: string[] | null;
  allowedOperatorIds: string[] | null;
  allowedRiskLevels: string[] | null;
  isGlobalAccess: boolean;
}

export interface UserApplication {
  applicationId: string;
  applicationName: string;
  userType: number;
  userTypeName: string;
  applicationRoles: string[];
  permissions: Record<string, string[]>;
  dataScope: UserDataScope | null;
  jurisdictions: UserJurisdiction[];
}

export interface UserInfo {
  applications: UserApplication | UserApplication[];
  operatorId?: string | null;
  name?: string;
  location?: string;
  email?: string;
  clientName?: string;
  clientId?: string;
}

// The registered applicationName for this app within the SSO portal's
// `applications[]` payload (same entry ACT.KYC.Console uses). It's
// "Act.Verify", the name the Auth Portal routes on and uses to show the KYC
// Demo link; "Act.Id" never matched, so the role always showed "Guest"
// (SID-2235).
export const KYC_APPLICATION_NAME = "Act.Verify";

function toApplicationsArray(
  applications: UserApplication | UserApplication[] | undefined
): UserApplication[] {
  if (Array.isArray(applications)) return applications;
  if (applications) return [applications];
  return [];
}

export function getApplicationEntry(
  userInfo: UserInfo | null | undefined,
  applicationName: string
): UserApplication | undefined {
  const applications = toApplicationsArray(userInfo?.applications);
  return applications.find((app) => app.applicationName === applicationName);
}
